export default "__VITE_ASSET__5pzkWW4D__"